import React from 'react';
import './Page.css';

const UrgentCare = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Urgent Care</h1>
        <p>Aspen Quick Care provides treatment for non-life-threatening illnesses and injuries, including acute sickness, minor injuries, infections, and common urgent medical needs. Walk in's welcome.</p>
        <br></br>
        <p><strong>Contact Us</strong></p>
        <div className="urgent-care-phones" style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
          <div>
            <div><strong>Spring Creek</strong></div>
            <a href="tel:7757383000">775-738-3000</a>
          </div>
          <div>
            <div><strong>Elko</strong></div>
            <a href="tel:7759932800">775-993-2800</a>
          </div>
        </div>
        <br></br>
        <p>If you are experiencing a medical emergency to life or limb, please <strong>DIAL 911 IMMEDIATELY</strong>.</p>
        <p>Medical emergencies may include, but are not limited to:</p>
        <ul>
          <li>Chest pain</li>
          <li>Symptoms of a stroke (such as facial drooping, arm or leg weakness, or difficulty speaking)</li>
          <li>Shortness of breath</li>
          <li>Severe trauma or uncontrolled bleeding</li>
          <li>Severe abdominal pain</li>
          <li>Drug overdose or accidental poisoning</li>
        </ul>
      </div>
    </div>
  );
};

export default UrgentCare;
